import React, { useCallback, useState, useEffect, useRef } from "react";
import { Alert, Box, Button, TextField, TextareaAutosize, Typography, setRef } from "@mui/material";
import { Check, ErrorOutline } from "@mui/icons-material";
import { getReminders } from "../utils/PoseUitils";
import { loggingApi } from "../services/backend";

const GestureAlertComponent = ({ gestureStatusRef, lastGestureReminderRef, isReadyRef }) => {
  const [gestureReminder, setGestureReminder] = useState({
    status: null,
    message: "",
  });

  useEffect(() => {
    const reminderInterval = 2000;
    const intervalId = setInterval(() => {
      if (isReadyRef.current) {
        try {
          const _reminders = getReminders(gestureStatusRef.current);
          // loggingApi({ message: { reminders: `${_reminders.toString()}` } }).then(() => {});
          // console.log(_reminders);
          let _gestureReminder = {};
          // setGestureReminder({ status: "new", message: `${_reminders.length}` });
          if (_reminders.length > 0) {
            if (lastGestureReminderRef.current.message !== _reminders[0]) {
              _gestureReminder = {
                status: "new",
                message: _reminders[0],
              };
            }
          } else {
            if (lastGestureReminderRef.current.status === "new") {
              // console.log("done");
              _gestureReminder = {
                status: "done",
                message: lastGestureReminderRef.current.message,
              };
            } else if (lastGestureReminderRef.current.status === "done") {
              // console.log("reset done");
              _gestureReminder = {
                status: null,
                message: "",
              };
            }
          }
          setGestureReminder(_gestureReminder);
          lastGestureReminderRef.current = {
            ...lastGestureReminderRef.current,
            ..._gestureReminder,
            lastDate: new Date(),
          };
        } catch (error) {
          console.log(error);
          setGestureReminder({ status: "new", message: "ERROR!!!!" });
          loggingApi({ message: { error: `error: ${error.message}` } }).then(() => {});
          // setGestureReminder({ status: "new", message: error.message });
        }
      }
    }, reminderInterval);
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <Box>
      {gestureReminder.status ? (
        <Alert
          icon={gestureReminder.status === "done" ? <Check fontSize="large" /> : <ErrorOutline fontSize="large" />}
          severity="success"
          color={gestureReminder.status === "done" ? "success" : "warning"}
        >
          <Typography sx={{ fontSize: 24 }}>{gestureReminder.message}</Typography>
        </Alert>
      ) : null}
    </Box>
  );
};

export { GestureAlertComponent };
